import { inject } from '@angular/core';
import { CanMatchFn, RedirectCommand, Router } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { map, Observable } from 'rxjs';

export const AUTH_PENDING_ROUTE = '/callback';

/**
 * `autoLoginPartialRoutesGuard` for `canMatch` (NEXUS-UI-5).
 *
 * Unauthenticated, the library guard saves the requested URL, starts the SSO
 * redirect and returns `false` — which `canMatch` treats as "no route matches",
 * so the router throws NG04002. Park on the unguarded callback route (spinner)
 * instead; `skipLocationChange` keeps the requested URL in the address bar and
 * history so Back from SSO doesn't land on a bare `/callback`. The post-login
 * return still uses the URL the library saved.
 *
 * `canActivate` doesn't need this (`false` just cancels there). Keep it first
 * in `canMatch` so its redirect wins over `hasPermission`.
 */
export const authCanMatchGuard: CanMatchFn = () =>
  redirectUnauthenticatedToCallback(autoLoginPartialRoutesGuard());

export function redirectUnauthenticatedToCallback(
  isAuthenticated$: Observable<boolean>,
  router = inject(Router)
): Observable<true | RedirectCommand> {
  return isAuthenticated$.pipe(
    map(
      (isAuthenticated) =>
        isAuthenticated ||
        new RedirectCommand(router.parseUrl(AUTH_PENDING_ROUTE), {
          skipLocationChange: true,
        })
    )
  );
}
